import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyFailSection } from './components/WhyFailSection';
import { SolutionReveal } from './components/SolutionReveal';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PaymentSection } from './components/PaymentSection';
import { OfferStack } from './components/OfferStack';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SalesNotification } from './components/SalesNotification';
import { initMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-brown-deep selection:bg-rose selection:text-brown-deep" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhyFailSection data-id="element-3" />
      <SolutionReveal data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PaymentSection data-id="element-8" />
      <OfferStack data-id="element-9" />
      <FAQSection data-id="element-10" />
      <Footer data-id="element-11" />
      <SalesNotification data-id="element-12" />
    </div>;
}